import React from 'react';
import { motion } from 'framer-motion';
import my_cv from '../assets/Seif-Elshimy_Resume_FrontEnd_React.Js.pdf';
import { HiOutlineDownload, HiOutlineArrowRight } from "react-icons/hi";
import { fadeInUp, staggerContainer } from '../utils/animationVariants';

const Hero = () => {
    return (
        <motion.section
            variants={staggerContainer}
            initial="hidden"
            animate="visible"
            className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4 pt-6 overflow-hidden"
        >
            <motion.div
                variants={fadeInUp}
                className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold/10 border border-gold/20 text-gold text-xs font-bold uppercase tracking-widest mb-6"
            >
                <span className="relative flex h-2 w-2">
                    {/* Replaced animate-ping with a static pulse for performance */}
                    <span className="absolute inline-flex h-full w-full rounded-full bg-gold opacity-30 animate-pulse"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-gold"></span>
                </span>
                Frontend Developer | Open to Opportunities
            </motion.div>

            <motion.h1
                variants={fadeInUp}
                className="text-white text-5xl md:text-8xl font-black leading-[0.9] tracking-tightest max-w-4xl mb-8"
                style={{ willChange: 'transform, opacity' }}
            >
                Crafting <span className="text-gradient-gold">Responsive</span> & High-Performance Web Solutions
            </motion.h1>

            <motion.p
                variants={fadeInUp}
                className="text-text-secondary-dark text-lg md:text-xl font-medium leading-relaxed max-w-3xl mb-12"
                style={{ willChange: 'transform, opacity' }}
            >
                Frontend Developer specializing in building modern, responsive, and user-focused web applications using React.js, TypeScript, HTML, and CSS with clean architecture and SOLID principles.
            </motion.p>

            <motion.div
                variants={fadeInUp}
                className="flex flex-col sm:flex-row items-center gap-6"
            >
                <motion.a
                    href="#portfolio"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="group px-8 py-4 rounded-full bg-white text-charcoal-dark font-bold text-base flex items-center gap-2 hover:bg-gold transition-colors"
                >
                    View Selected Works
                    <HiOutlineArrowRight className="group-hover:translate-x-1 transition-transform" />
                </motion.a>

                <motion.a
                    href={my_cv}
                    target="_blank"
                    rel="noreferrer"
                    download
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="px-8 py-4 rounded-full border border-white/10 text-white font-bold text-base flex items-center gap-2 hover:bg-white/5 transition-colors"
                >
                    Download CV
                    <HiOutlineDownload className="text-gold" />
                </motion.a>
            </motion.div>



        </motion.section>
    );
};

export default Hero;
